<template>
  <v-dialog
    no-click-animation
    hide-overlay
    :overlay-opacity="0"
    transition="fade-transition"
    fullscreen
    persistent
    :value="isOpen ? true : false"
  >
    <v-card class="installation-card d-flex align-center mb-16">
      <div class="mx-auto align-center px-8 d-flex flex-column mt-8">
        <div class="d-flex justify-center">
          <v-img
            v-if="isLogoBase64 || !customLogo"
            :width="$vuetify.breakpoint.mobile ? 171 : 200"
            :height="$vuetify.breakpoint.mobile ? 36 : 44"
            :src="customLogo ? customLogo : require(`@/assets/logo${isDark ? '-white' : ''}.svg`)"
            contain
            position="center center"
          />
          <div v-else v-html="customLogo" class="mb-10 d-flex">
          </div>
        </div>
        <div class="d-flex justify-center pt-16">
          <h1 class="text--center d-flex flex-column align-center">
            <span class="text-center primary--text" v-if="!error && completed">
              {{ $t('heading.onboarding.import.success.title') }}
            </span>
            <span
              class="text-center error--text"
              v-else-if="error && completed"
            >{{ $t("heading.onboarding.import.failed.title") }}</span
            >
            <span class="text-center" v-if="!completed">{{
                $t("heading.onboarding.import.inProgress.subtitle")
              }}</span>
            <span class="text-center" v-else-if="completed && !error">{{
                $t('heading.onboarding.import.success.subtitle')
              }}</span>
            <span class="text-center" v-else-if="completed && error">{{
                $t("heading.onboarding.import.failed.subtitle")
              }}</span>
          </h1>
        </div>


        <div
          v-if="!completed || error"
          class="mt-8 installation-card__image"
          :class="
            !completed
              ? 'installation-card__image--working'
              : error
              ? 'installation-card__image--error'
              : 'installation-card__image--success'
          "
        >
          <loader
            :completed="completed"
            :size="120"
            :width="12"
            color="#ffffff"
          >
            <v-img v-if="!completed" src="../../assets/LogoPartialWhite.svg"/>
            <v-img v-if="completed && error" src="../../assets/Failed.svg"/>
          </loader>
        </div>

        <div class="text-center">
          <p v-if="completed && !error" class="p-1 heading--text my-8">
            {{ $t('heading.onboarding.import.success.info.general') }}
          </p>
          <p v-else-if="!completed" class="p-1 pt-8 mb-0 text-center heading--text">
            {{ $t('heading.onboarding.import.inProgress.info.general') }}
          </p>
          <p v-else class="p-1 pt-8 mb-0 text-center heading--text">
            {{ $t('heading.onboarding.import.failed.info.general') }}
          </p>
        </div>

        <div v-if="completed && !error" class="success-box mb-5">
          <span class="font-weight-600"> </span>
          <i18next :translation="$t('heading.onboarding.import.success.info.domain')">
            <template #domain>
              <br/>
              <a
                :href="importedInstance.url"
                class="h5 font-weight-600"
                target="_blank"
              >
                {{ importedInstance.url }}
              </a>
            </template>
          </i18next>
        </div>

        <div v-if="completed" class="d-flex justify-center my-8">
          <v-btn color="primary" x-large elevation="0" @click="$emit('next')">
            <span class="font-weight-600">{{ $t('button.returnToDashboard') }}</span>
          </v-btn>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import Loader from "@/components/Loader.vue";

export default {
  components: {Loader},
  props: {
    isOpen: Boolean,
    completed: Boolean,
    error: Boolean,
    importedInstance: Object,
    nameservers: Array,
  },
  data: function () {
    return {
      copiedText: "",
      copySetTimeout: null,
    };
  },
  methods: {
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      this.copiedText = text;
    },
    resetData() {
    },
  },
  watch: {
    copiedText: function (value) {
      this.copySetTimeout && clearTimeout(this.copySetTimeout);

      if (value) {
        setTimeout(() => {
          this.copiedText = "";
        }, 10000);
      }
    },
    isOpen: function (value) {
      this.resetData();

      if (value) {
        this.$nextTick(() => {
          this.$store.dispatch("lockBodyScroll");
          setTimeout(() => {
            document.querySelector("html").classList.add("overflow-y-hidden");
          }, 300);
        });
      } else {
        this.$store.dispatch("unlockBodyScroll");
        document.querySelector("html").classList.remove("overflow-y-hidden");
      }
    },
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    },
    isDemo() {
      return this.$store.state.home.user.email == "demo@panelalpha.com";
    },
    customLogo: function () {
      if (this.$vuetify.theme.dark && this.$store.state.ThemeModule.darkLogo) {
        return this.$store.state.ThemeModule.darkLogo
      }

      if (!this.$vuetify.theme.dark && this.$store.state.ThemeModule.lightLogo) {
        return this.$store.state.ThemeModule.lightLogo
      }

      return false
    },
    isLogoBase64: function () {
      return this.customLogo && this.customLogo.trim().startsWith('data:image/');
    }
  },
};
</script>

<style lang="scss" scoped>
.v-dialog {
  overflow: auto !important;
}

.v-text-field--outlined::v-deep {
  > .v-input__control > .v-input__slot {
    background-color: #fff;
  }
}

.installation-card {
  max-height: 100vw;
  max-width: 100vw;
  display: flex;
  align-items: center;
  background: var(--v-body-base) !important;

  > div {
    max-width: 684px;
    width: 100%;
  }

  .success-box {
    width: 100%;
    background: var(--v-primary-lighten4);
    color: var(--v-primary-base);
    padding: 16px;
    text-align: center;
    border-radius: 8px;
  }

  .form-box {
    border: 1px solid var(--v-gray-lighten4);
    border-radius: 8px;
    padding: 16px;
  }
}

h1 {
  font-size: $font-size-h1;
  line-height: $line-height-h1;
}

.p-1 {
  font-size: $font-size-xlg;
  line-height: $line-height-xlg;
  font-weight: $font-weight-extra-light;
}

.v-btn.v-size--x-large {
  height: 60px;
  padding: 16px;
}
</style>
